import { render, staticRenderFns } from "./tip-bottom.vue?vue&type=template&id=37e78308&"
import script from "./tip-bottom.vue?vue&type=script&lang=js&"
export * from "./tip-bottom.vue?vue&type=script&lang=js&"
import style0 from "./tip-bottom.vue?vue&type=style&index=0&id=37e78308&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports